import { render, staticRenderFns } from "./WordList.vue?vue&type=template&id=6dbc1b05&scoped=true&"
import script from "./WordList.vue?vue&type=script&lang=js&"
export * from "./WordList.vue?vue&type=script&lang=js&"
import style0 from "./WordList.vue?vue&type=style&index=0&id=6dbc1b05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbc1b05",
  null
  
)

export default component.exports